export const ERROR = 'ERROR';
export const LOADING = 'LOADING';
export const INITIATE_RENT_PAYMENT_APPLICATION_SUCCESS = 'INITIATE_RENT_PAYMENT_APPLICATION_SUCCESS';
export const CLEAR_RENT_PAYMENT_APPLICATION_ERROR = 'CLEAR_RENT_PAYMENT_APPLICATION_ERROR';
export const FETCH_APPLICATION_RENT_PAYMENT_SUCCESS = 'FETCH_APPLICATION_RENT_PAYMENT_SUCCESS';
export const FETCH_PROPERTY_RENT_PAYMENT_SUCCESS = 'FETCH_PROPERTY_RENT_PAYMENT_SUCCESS';
export const FETCH_BANKLIST_RENT_PAYMENT_SUCCESS = 'FETCH_BANKLIST_RENT_PAYMENT_SUCCESS';
export const FETCH_DOCUMENTS_RENT_PAYMENT_SUCCESS = 'FETCH_DOCUMENTS_RENT_PAYMENT_SUCCESS';
export const SAVE_APPLICATION_RENT_PAYMENT_SUCCESS = 'SAVE_APPLICATION_RENT_PAYMENT_SUCCESS';
export const CHANGE_RENT_PAYMENT_STEP = 'CHANGE_RENT_PAYMENT_STEP';
export const RENT_PAYMENT_CLEAR_DATA = 'RENT_PAYMENT_CLEAR_DATA';
export const DOWNLOAD_DOCUMENT_RENT_PAYMENT_SUCCESS = 'DOWNLOAD_DOCUMENT_RENT_PAYMENT_SUCCESS';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';
export const CHECKOUT_RENT_PAYMENT_APPLICATION = 'CHECKOUT_RENT_PAYMENT_APPLICATION';
export const CHECKOUT_RENT_PAYMENT_APPLICATION_SUCCESS = 'CHECKOUT_RENT_PAYMENT_APPLICATION_SUCCESS';
export const RENT_PAYMENT_CANCEL_APPLICATION_SUCCESS = 'RENT_PAYMENT_CANCEL_APPLICATION_SUCCESS';
export const APPROVAL_RENT_PAYMENT_SUCCESS = 'APPROVAL_RENT_PAYMENT_SUCCESS';
export const POST_RETURN_RENT_PAYMENT_SUCCESS = 'POST_RETURN_RENT_PAYMENT_SUCCESS';
export const RENT_PAYMENT_PAYMENT_BREAKDOWN_SUCCESS = 'RENT_PAYMENT_PAYMENT_BREAKDOWN_SUCCESS';
export const PAY_IN_ADVANCE_YEARS = 'PAY_IN_ADVANCE_YEARS';
export const RENT_PAYMENT_PROPERTY_DOCUMENTS_SUCCESS = 'RENT_PAYMENT_PROPERTY_DOCUMENTS_SUCCESS';
